<div class="dropdown-menu__dropdown" *ngIf="isActive">
    <ng-content></ng-content>
</div>
